import { stripHtml, formatMoney } from '@/helpers'

export default {
  computed: {
    variant() {
      return this.item.variants ? this.item.variants[0] : {}
    },
    available() {
      return this.item.variants.find(x => x.availableForSale)
    },
    sold_out() {
      return !this.available
    },
    on_sale() {
      return this.compare_at_price > this.price
    },
    price() {
      return this.item.price
    },
    compare_at_price() {
      return this.item.variants.reduce((prev, curr) =>
        parseFloat(prev.compareAtPrice) < parseFloat(curr.compareAtPrice)
          ? prev
          : curr
      )
    },
    price_varies() {
      const prices = []
      this.item.variants.forEach(function(x) {
        if (!prices.includes(x.price)) prices.push(x.price)
      })
      return prices.length > 1
    },
    compare_at_price_varies() {
      const prices = []
      this.item.variants.forEach(function(x) {
        if (!prices.includes(x.compare_at_price))
          prices.push(x.compare_at_price)
      })
      return prices.length > 1
    }
  },
  methods: {
    formatImageSrc(src, { size, scale, crop, format } = {}) {
      const match = src.match(/(.*\/products\/)(.*)\.(?=[^.]*)([^?]*)(.*)/i)
      if (match === null) {
        return src
      }
      let prefix = match[1]
      let name = match[2]
      let ext = match[3]
      let suffix = match[4]

      // concatenate src from parts
      let result = `${prefix}${name}`
      if (size) {
        result = `${result}_${size}`
      }
      if (crop) {
        result = `${result}_crop_${crop}`
      }
      if (scale && (scale == 2 || scale == 3)) {
        result = `${result}@${scale}x`
      }
      if (format) {
        if (format == 'jpg') {
          result = `${result}.${ext}`
        }
        if (format == 'pjpg') {
          result = `${result}.progressive.${ext}`
        }
      } else {
        result = `${result}.${ext}`
      }
      return `${result}${suffix}`
    },
    imageSrc(options) {
      let src = this.inner
        ? this.inner.image || this.item.image
        : this.item.image
      return this.formatImageSrc(src, options)
    },
    secondarySrc(options) {
      let src = this.inner
        ? this.inner.secondary || this.item.secondary
        : this.item.secondary
      return this.formatImageSrc(src, options)
    },
    currency(value) {
      return '<span class="money">' + formatMoney(value) + '</span>'
    },
    stripHtml(value) {
      return stripHtml(value)
    }
  }
}
